import React from 'react';

import { Button, Segment } from 'semantic-ui-react';

import { SortableElement } from 'react-sortable-hoc';

import DragHandle from '../DragHandle';

const SortableQuestionItem = SortableElement(({ question, onRemove }) => (
  <Segment className="question-item">
    <div className="question-content">
      <DragHandle />
      <div className="question-text">{question.text}</div>
      <Button
        className="action-button compact"
        icon="remove"
        onClick={() => onRemove(question.id)}
        title="Remove from group"
      />
    </div>
  </Segment>
));

export default SortableQuestionItem;
